import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import LogbookCard from "src/components/shared/LogbookCard/LogbookCard";
import { type ILogbookData } from "src/pages/Home/Home.types";

const LogbookCardWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer;

  /* Override the LogbookCard height to fill container */
  > div {
    height: 100% !important;
    width: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  @media (max-width: 768px) {
    > div {
      max-width: 100% !important;
    }
  }
`;

interface Props {
  lbid: string;
  data: ILogbookData;
}

const DashboardLogbookCard = ({ lbid, data }: Props) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // Navigate to the logbook based on the latest entry type
    if (data.latest) {
      const idType = data.lbtype === "logbook" ? "lbeid" : "partid";
      const id = data.latest.lbeid ?? data.latest.partid;
      navigate(`/logbook/${lbid}/${idType}/${id}`, { replace: true });
    } else {
      // No entries, navigate to create new entry
      const idType = data.lbtype === "logbook" ? "lbeid" : "partid";
      if (data.lbtype === "collection") {
        navigate(`/collection/${lbid}`, { replace: true });
      } else {
        navigate(`/logbook/${lbid}/${idType}`, { replace: true });
      }
    }
  };
  // Transform the data to match LogbookCard props
  const cardProps = {
    lbid,
    lbname: data.lbname,
    lbtype: data.lbtype,
    latest: data.latest,
    open: data.latest?.open ?? 0,
    reverify: data.latest?.reverify ?? 0,
    lastentryDate: data.latest?.entrydate?.split(" ")[0] ?? "",
    lastentryTime: data.latest?.entrydate?.split(" ")[1] ?? "",
    status: "active" as const,
    showPreview: false,
  };
  return (
    <LogbookCardWrapper onClick={handleClick}>
      <LogbookCard {...cardProps} />
    </LogbookCardWrapper>
  );
};

export default DashboardLogbookCard;
